module.exports = __webpack_public_path__ + "static/media/lb.c43e467f.svg";